import Select from 'react-select'
import {MultiSelectOption} from '../models/MultiSelectOption'

interface ListProps {
  setSelectedOption: React.Dispatch<React.SetStateAction<any>>
  options: MultiSelectOption[]
  defaultValues?: MultiSelectOption[]
  isMulti?: boolean
  isClearable?: boolean
}

const MultiSelect = ({setSelectedOption, options, defaultValues, isMulti = true,isClearable=true}: ListProps) => {
  if (typeof defaultValues === 'undefined') {
    return (
      <Select
        onChange={setSelectedOption}
        options={options}
        isMulti={isMulti}
        isSearchable={true}
        closeMenuOnSelect={!isMulti}
        isClearable={isClearable}
      />
    )
  }

  return (
    <Select
      onChange={setSelectedOption}
      options={options}
      isMulti={isMulti}
      isSearchable={true}
      value={typeof defaultValues !== 'undefined' && defaultValues !== null ? defaultValues : []}
      closeMenuOnSelect={!isMulti}
    />
  )
}

export {MultiSelect}
